module.exports = __webpack_public_path__ + "static/media/Pallets4Del-Logo.f055a1fe.png";